import axios from "axios";
import { BACKEND } from "@/lib/api";

/** Dedicated client for the couples' portal — never sends the admin token. */
export const portalApi = axios.create({
  baseURL: `${BACKEND}/api/wedding-portal`,
  withCredentials: true,
});

portalApi.interceptors.request.use((config) => {
  const t = sessionStorage.getItem("wedding_session");
  if (t) {
    config.headers = config.headers || {};
    config.headers["X-Wedding-Session"] = t;
  }
  return config;
});

export function portalError(e) {
  const d = e?.response?.data?.detail;
  if (!d) return "Une erreur est survenue. Veuillez réessayer.";
  if (typeof d === "string") return d;
  if (Array.isArray(d?.errors)) return d.errors.join(" · ");
  if (Array.isArray(d)) return d.map((x) => x.msg || JSON.stringify(x)).join(" ");
  return JSON.stringify(d);
}

export const euros = (cents) =>
  `${((cents || 0) / 100).toLocaleString("fr-FR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €`;

export const frDate = (iso) => {
  if (!iso) return "";
  try {
    return new Date(`${iso}T12:00:00`).toLocaleDateString("fr-FR", {
      weekday: "long", day: "numeric", month: "long", year: "numeric",
    });
  } catch {
    return iso;
  }
};
